export type { VacancyTableProps } from "./vacancy-table";
export { VacancyTable } from "./vacancy-table";
